import {IClient} from '../../interfaces/dtos';
import {IOrderCandidate} from '../../interfaces/services/candidate-order-detail-response.interface';
import {IOrder} from '../commons/interfaces';
import {IOrderItem, IProduct} from '../user/Types';
import {IState} from './Types';

const syncRequest = (
  property: 'customerRegistryList' | 'paymentReportList' | 'salesOrderList',
  state: IState,
  payload: any,
): IState => {
  const requestDate = payload as Date;
  if (state.requestsToSync) {
    const {requestsToSync} = state;

    requestsToSync[property] = requestsToSync[property].filter((item: any) => {
      return item.createdAt.toString() !== requestDate.toString();
    });

    const newState = {
      ...state,
      requestsToSync,
    } as IState;

    return newState;
  }

  const newState = {
    ...state,
    requestsToSync: payload,
  } as IState;
  return newState;
};

const parseCandidateOrder = (
  candidate: IOrderCandidate,
  client: IClient,
  productList: IProduct[],
) => {
  const {
    paymentOptionId,
    foreign,
    priceListId,
    requestTransportQuote,
    transport,
    items: sourceItems,
  } = candidate;

  const items: IOrderItem[] = [];

  sourceItems.forEach(item => {
    const {count, price, productId, unitId} = item;
    const product = productList?.find(e => e.id === productId);
    const unit = product?.units.find(e => e.id === unitId);
    if (product && unit && count && price) {
      items.push({count, price, product, unit} as IOrderItem);
    }
  });

  const customerOrder = {
    id: null,
    client: client,
    items,
    transport: transport ?? null,
    date: new Date(),
    paymentOptionId,
    foreign,
    priceListId,
    requestTransportQuote,
  } as IOrder;

  return customerOrder;
};

/**
 *
 */
export const parser = {
  /**
   *
   * @param payload
   */
  sigin: (payload: any) => {
    if (payload) {
      const {id, token, begin, lifetime} = payload.credentials;
      const {email} = payload.info;
      const {
        entities,
        banks,
        profile,
        faq,
        phone,
        uiConfiguration,
        whatsApp,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
      } = payload;

      return {
        id,
        email,
        session: {
          begin,
          lifetime,
          token,
        },
        entities,
        banks,
        profile,
        faq,
        whatsApp,
        phone,
        uiConfiguration,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
      } as unknown as IState;
    }
  },

  processResources: (state: IState, payload: any) => {
    if (payload) {
      const {
        salesTerritories,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
        salesCategories,
        salesCities,
      } = payload;

      return {
        ...state,
        salesTerritories,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
        salesCategories,
        salesCities,
      } as IState;
    }
  },

  balanceSheetSalesman: (state: IState, payload: any): IState => {
    return {
      ...state,
      balanceSheet: payload,
    } as IState;
  },
  salesmanClientList: (state: IState, payload: any): IState => {
    return {
      ...state,
      clients: payload ?? [],
    } as IState;
  },
  salesmanProductList: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanProductList: payload,
    } as IState;
  },
  setSalesmanProductToAdd: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanProductToAdd: payload,
    } as IState;
  },
  updateSalesmanNewOrder: (state: IState, payload: any): IState => {
    return {
      ...state,
      customerOrder: payload,
    } as IState;
  },
  updateCandidateToShoppingCart: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanOrderItemCandidate: payload,
    } as IState;
  },
  setSalesmanClient: (state: IState, payload: any): IState => {
    return {
      ...state,
      client: payload,
    } as IState;
  },
  sendSalesmanNewOrder: (state: IState): IState => {
    return {
      ...state,
      salesmanProductToAdd: null,
      salesmanOrderItemCandidate: null,
    } as IState;
  },
  fetchBalanceCustomer: (state: IState, payload: any): IState => {
    return {
      ...state,
      balanceCustomer: payload,
    } as IState;
  },
  setNewSalesmanClientRequest: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanNewClientRequest: payload ?? [],
    } as IState;
  },
  processNewClientRequest: (state: IState): IState => {
    return {
      ...state,
      salesmanNewClientRequest: null,
    } as IState;
  },
  setClientHistory: (state: IState, payload: any): IState => {
    return {
      ...state,
      history: payload ?? [],
    } as IState;
  },
  balanceList: (state: IState, payload: any): IState => {
    return {
      ...state,
      balances: payload ?? [],
    } as IState;
  },
  semaphoreItems: (state: IState, payload: any): IState => {
    return {
      ...state,
      semaphoreItems: payload ?? [],
    } as IState;
  },
  debtorList: (state: IState, payload: any): IState => {
    return {
      ...state,
      debtors: payload ?? [],
    } as IState;
  },
  receivableList: (state: IState, payload: any): IState => {
    return {
      ...state,
      receivables: payload ?? [],
    } as IState;
  },

  setPortfolioFilter: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanPortfolioFilter: payload,
    } as IState;
  },

  setSalesmanOrderList: (state: IState, payload: any): IState => {
    return {
      ...state,
      orderList: payload,
    } as IState;
  },
  setSalesmanOrderDetail: (state: IState, payload: any): IState => {
    return {
      ...state,
      orderDetail: payload,
    } as IState;
  },
  setSalesmanOrderFilter: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanOrderFilter: payload,
    } as IState;
  },
  setSchedule: (state: IState, payload: any): IState => {
    return {
      ...state,
      schedule: payload,
    } as IState;
  },

  setAppointment: (state: IState, payload: any): IState => {
    return {
      ...state,
      appointment: payload,
    } as IState;
  },
  setState: (field: string, state: IState, payload: any): IState => {
    const newState = {
      ...state,
    } as IState;
    (newState as any)[field] = payload;
    return newState;
  },
  sendInvoiceRequest: (state: IState, payload: boolean): IState => {
    const invoiceRequest = null;

    if (payload) {
      return {
        ...state,
        invoiceRequest,
      } as IState;
    }
    return {
      ...state,
    } as IState;
  },
  syncNewCustomer: (state: IState, payload: any): IState => {
    return syncRequest('customerRegistryList', state, payload);
  },
  syncPaymentProofReport: (state: IState, payload: any): IState => {
    return syncRequest('paymentReportList', state, payload);
  },
  syncNewSalesOrder: (state: IState, payload: any): IState => {
    return syncRequest('salesOrderList', state, payload);
  },
  buildFropmCandidateToCustomerOrder: (state: IState, payload: any): IState => {
    const {client, salesmanProductList} = state;

    if (client && salesmanProductList) {
      const customerOrder = parseCandidateOrder(
        payload,
        client,
        salesmanProductList,
      );

      return {
        ...state,
        customerOrder,
      } as IState;
    }
    throw new Error('Fail updating state');
  },
};
